import { render, staticRenderFns } from "./DateChip.vue?vue&type=template&id=33fedb6e&scoped=true"
import script from "./DateChip.vue?vue&type=script&lang=js"
export * from "./DateChip.vue?vue&type=script&lang=js"
import style0 from "./DateChip.vue?vue&type=style&index=0&id=33fedb6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fedb6e",
  null
  
)

export default component.exports